
export default {
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    offLabel: {
      type: String,
      default: "Off"
    },
    onLabel: {
      type: String,
      default: "On"
    },
    rightLabel: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tracking: {
      type: [Object, Array],
      default: null
    }
  },
  computed: {
    ariaLabel() {
      return this.rightLabel ?? this.label
    }
  },
  methods: {
    updateInput(event) {
      this.$emit("change", event.target.checked)
    },
    removeFocus(event) {
      if (event.clientX || event.clientY) {
        event.target.blur()
      }
    }
  }
}
